import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import RootLayout from 'routes/RootLayout.jsx';
import { AuthProvider } from 'context/authContext';
import { ConfigProvider } from 'antd';
import {
  LoginPage,
  AdminDashboard,
  CreateClientByAdmin,
  AdminClients,
  AdminPartners,
  CreatePartner,
  AdminFinances,
  ClientLoginPage,
  ManagerDashboard,
  ManagerClients,
  CreateClientByManager,
  ManagerFinances,
  AdminSingleClient,
  ManagerSingleClient,
  ClientDashboard,
  ClientProfile,
  EditPartner,
  WeeklyForms,
  WeeklyFormsAdmin,
  EditClient,
  EditClientByManager,
  WeeklyFormsManager,
  PF25Admins,
  ViewPartner,
  SlhManagers,
  SLHChilds,
  CreateChildPartner,
  AdminSlhManagers,
  AdminProfile,
  ManagerProfile,
} from 'pages';
import ProtectedManagerRoute from 'routes/ProtectedManagerRoute';
import ProtectedAdminRoute from 'routes/ProtectedAdminRoute';
import { UserProvider } from 'context/userContext';
import { IsAuthenticated, NotificationBlock, VerifyInvitation } from 'components';
import ProtectedClientRoute from 'routes/ProtectedClientRoute';
import RootLayoutClient from 'routes/RootLayoutClient';
import { ViewChildPartner } from 'pages/manager/viewChildPartner';
import { ROLE_TYPES } from 'api/constants';
import { getRoleFromHostname } from 'api/roleConfig';
import { COLORS } from 'utils/colors';

function App() {
  const hostname = window.location.hostname;
  const role = getRoleFromHostname(hostname);

  return (
    <ConfigProvider
      theme={{
        hashed: false,
        token: {
          colorPrimary: COLORS.orange,
        },
      }}
    >
      <Router>
        <AuthProvider>
          <UserProvider>
            <Routes>
              {role === ROLE_TYPES.admin && (
                <>
                  <Route path="/" element={<LoginPage />} />
                  <Route path=":verification_code" element={<VerifyInvitation />} />
                  <Route
                    element={
                      <ProtectedAdminRoute>
                        <RootLayout />
                      </ProtectedAdminRoute>
                    }
                  >
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="create-client" element={<CreateClientByAdmin />} />
                    <Route path="clients" element={<AdminClients />} />
                    <Route path="client/:user_id" element={<AdminSingleClient />} />
                    <Route path="admin-profile/:admin_id" element={<AdminProfile />} />
                    <Route
                      path="slh-manager-profile/:manager_id"
                      element={<ManagerProfile role={ROLE_TYPES.admin} />}
                    />
                    <Route path="edit-client/:user_id" element={<EditClient />} />
                    <Route
                      path="client/:user_id/weekly-forms/:week_id"
                      element={<WeeklyFormsAdmin />}
                    />
                    <Route path="create-partner" element={<CreatePartner />} />
                    <Route path="partners" element={<AdminPartners />} />
                    <Route
                      path="partner/:partner_id"
                      element={<EditPartner domain={ROLE_TYPES.admin} />}
                    />
                    <Route path="partner/view/:partner_id" element={<ViewPartner />} />
                    <Route path="finances" element={<AdminFinances />} />
                    <Route path="pf25-admins" element={<PF25Admins />} />
                    <Route path="slh-managers" element={<AdminSlhManagers />} />
                    <Route path="*" element={<IsAuthenticated />} />
                  </Route>
                </>
              )}
              {role === ROLE_TYPES.slh_manager && (
                <>
                  <Route path="/" element={<LoginPage />} />
                  <Route path=":verification_code" element={<VerifyInvitation />} />
                  <Route
                    element={
                      <ProtectedManagerRoute>
                        <RootLayout />
                      </ProtectedManagerRoute>
                    }
                  >
                    <Route path="dashboard" element={<ManagerDashboard />} />
                    <Route path="clients" element={<ManagerClients />} />
                    <Route path="create-client" element={<CreateClientByManager />} />
                    <Route path="edit-client/:user_id" element={<EditClientByManager />} />
                    <Route path="finances" element={<ManagerFinances />} />
                    <Route
                      path="slh-manager-profile/:manager_id"
                      element={<ManagerProfile role={ROLE_TYPES.slh_manager} />}
                    />
                    <Route path="client/:user_id" element={<ManagerSingleClient />} />
                    <Route
                      path="client/:user_id/weekly-forms/:week_id"
                      element={<WeeklyFormsManager />}
                    />
                    <Route path="create-partner" element={<CreateChildPartner />} />
                    <Route path="slh-managers" element={<SlhManagers />} />
                    <Route path="slh-children" element={<SLHChilds />} />

                    <Route
                      path="partner/:partner_id"
                      element={<EditPartner domain={ROLE_TYPES.slh_manager} />}
                    />
                    <Route path="partner/view/:partner_id" element={<ViewChildPartner />} />
                    <Route path="*" element={<IsAuthenticated />} />
                  </Route>
                </>
              )}
              {role === ROLE_TYPES.client && (
                <>
                  <Route path="/login" element={<ClientLoginPage />} />
                  <Route
                    element={
                      <ProtectedClientRoute>
                        <RootLayoutClient />
                      </ProtectedClientRoute>
                    }
                  >
                    <Route path="dashboard" element={<ClientDashboard />} />
                    <Route path="me" element={<ClientProfile />} />
                    <Route path="weekly-forms/:week_index" element={<WeeklyForms />} />
                    <Route path="*" element={<IsAuthenticated />} />
                  </Route>
                </>
              )}
              <Route path="*" element={<IsAuthenticated />} />
            </Routes>
          </UserProvider>
        </AuthProvider>
      </Router>
      <NotificationBlock />
    </ConfigProvider>
  );
}

export default App;
